// eslint-disable-next-line no-unused-vars
import React from 'react';
import { browserHistory } from '@americanexpress/one-app-router';
import {
 OverflowMenu, OverflowMenuAction, IconButton, IconList, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
import labels from '../../constants/labels';
import { routes } from '../../constants/paths';

const overflowLabelOverrideStyle = {
  'button#overflow-menu-button > :nth-child(1)': { display: 'none' },
  'button#overflow-menu-button > :nth-child(2)': { clipPath: 'none', position: 'relative' },
  '> ul': {
    marginTop: '15px',
    zIndex: '99',
  },
};

const MenuButton = () => {
  const overflowLabel = (
    <IconButton styleType="primary" aria-label="Primary" size="sm" icon={<IconList />} style={{ width: '111px' }}>
      Menu
    </IconButton>
  );

  const onActionClick = (path) => {
    browserHistory.push(path);
  };

  return (
    <OverflowMenu
      id="overflow-menu-button"
      theme={overflowLabelOverrideStyle}
      label={overflowLabel}
      aria-live="polite"
      className="display-inline"
    >
      <OverflowMenuAction id="home-button" onClick={() => onActionClick(routes.home)}>
        {labels.HOME}
      </OverflowMenuAction>
      <OverflowMenuAction id="my-actions-button" onClick={() => onActionClick(routes.myActions)}>
        {labels.MY_ACTIONS}
      </OverflowMenuAction>
      <OverflowMenuAction id="manage-digital-assets-button" onClick={() => onActionClick(routes.manageDigitalAssets)}>
        {labels.MANAGE_DIGITAL_ASSETS}
      </OverflowMenuAction>
      <OverflowMenuAction id="manage-contact-info-button" onClick={() => onActionClick(routes.manageContacts)}>
        {labels.CONTACTS}
      </OverflowMenuAction>
    </OverflowMenu>
  );
};

export default MenuButton;

MenuButton.propTypes = {};
